import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-left',
  templateUrl: './section-left.component.html',
  styleUrls: ['./section-left.component.scss']
})
export class SectionLeftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
